<template>
  <div class="web-003-nav">
    <img
      v-if="websiteMsg.logo"
      class="logo"
      :src="websiteMsg.logo"
      alt=""
    >
    <div v-else />
    <div style="display: flex; align-items: center">
      <el-menu
        ref="elMenu"
        :default-active="activeIndex"
        mode="horizontal"
        text-color="#464C5B"
        active-text-color="#2873E9"
      >
        <template v-for="item in menu">
          <el-menu-item
            v-if="!item.child || !item.child.length"
            :key="item.catalogId"
            :index="item.catalogId"
            @click.native="onClick(item)"
          >
            {{ item.name }}
          </el-menu-item>
          <el-submenu
            v-else
            :key="item.catalogId"
            :index="item.catalogId"
            :class="{'is-active': item.catalogId == activeIndex}"
            @click.native="onClick(item)"
          >
            <template slot="title">
              {{ item.name }}
            </template>
            <el-menu-item
              v-for="itm in item.child"
              :key="itm.catalogId"
              :index="itm.catalogId"
              @click.native="onClick(itm)"
            >
              {{ itm.name }}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
      <YxpNav
        style="margin-left: 10px"
        :website-msg="websiteMsg"
      />
    </div>
  </div>
</template>

<script>
import api from '../../proxy';
import YxpNav from '../../../../common/YxpNav';
import { openUrl } from '../../../../../lib/utils';

export default {
    name: 'Navigation',
    components: { YxpNav },
    props: {
        websiteMsg: {
            type: Object,
            default: () => {},
        },
    },
    data () {
        return {
            activeIndex: '0',
            menu: [{
                id: '0',
                catalogId: '0',
                name: '首页',
            }],
        };
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
    },
    async mounted () {
        const query = this.$route.query;
        if (query.from === 'home') {
            this.activeIndex = '0';
        } else if (query.catalogId) {
            this.activeIndex = query.catalogId;
        }
        if (query.siteId) {
            this.websiteMsg.id = query.siteId;
        }
        const param = {
            siteId: this.websiteMsg.id,
        };
        const res = await api.getNavigation(param);
        if (res.errcode === 0) {
            const catalogList = res.data || [];
            this.setTreeNode(catalogList, this.menu, 1);
            // const currCatalog = catalogList.find(itm => itm.catalogId + '' === query.rootId);
        } else {
            this.$message.error(res.errmsg);
        }
    },
    methods: {
        onClick (item) {
            const query = this.$route.query;
            let routeUrl = '';
            if (item.catalogId === '-2') { // 应用中心
                routeUrl = this.$router.resolve({
                    path: '/webModulePage/appCenter',
                    query: { catalogId: item.catalogId, siteId: query.siteId, preview: query.preview },
                });
            } else if (item.catalogId === '-1') { // 个人空间
                routeUrl = { href: window.yxpapi.store.getters['runEnv/baseUrl'] + '/yxp-login/#/index' };
            } else if (item.catalogId === '0') { // 首页
                routeUrl = this.$router.resolve({
                    path: '/webModulePage/home',
                    query: { siteId: query.siteId, preview: query.preview },
                });
            } else { // articleList
                let catalogId = item.catalogId;
                const node = this.flatTreeList.find(itm => +itm.catalogId === +catalogId);
                if (node && node.type === 1 && node.catalogLink) {
                    openUrl(node.catalogLink);
                } else {
                    routeUrl = this.$router.resolve({
                        path: '/webModulePage/articleList',
                        query: { catalogId, siteId: this.websiteMsg.id, preview: query.preview },
                    });
                }
            }
            if (routeUrl) {
                openUrl(routeUrl.href);
            }
            this.$nextTick(() => {
                this.$refs.elMenu.activeIndex = this.activeIndex;
            });
        },
        setTreeNode (catalogList, menu, layer, parentId) {
            for (const item of catalogList) {
                const currentItem = {
                    name: item.name.replace(/\u200B/g, ''),
                    catalogId: item.catalogId + '',
                    id: item.id + '',
                };
                if (layer === 1 && currentItem.name.length > 5) {
                    currentItem.name = currentItem.name.substr(0, 4) + '…';
                }
                if (parentId) currentItem.parentId = parentId + '';
                // 导航最多显示2层
                if (item.child && item.child.length && layer < 2) {
                    currentItem.child = [];
                    this.setTreeNode(item.child, currentItem.child, layer + 1, item.catalogId);
                }
                menu.push(currentItem);
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "../style.scss";
.web-003-nav {
    height: 80px;
    width: 100%;
    min-width: $pageWidth;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 40px;
    padding-right: 0px;
    user-select: none;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    .logo {
        max-width: 420px;
        max-height: 50px;
        margin-right: 10px;
    }
    ::v-deep .el-menu.el-menu--horizontal {
        border-bottom: unset;
        display: flex;
    }
    ::v-deep .el-menu-item {
        font-size: 16px;
    }
    ::v-deep .el-submenu {
        .el-submenu__title {
            font-size: 16px;
        }
    }
    ::v-deep .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: 2px solid #2873E9;
        color: #2873E9;
    }
    ::v-deep .el-menu--horizontal>.el-submenu.is-active {
        .el-submenu__title {
            border-bottom: 2px solid #2873E9 !important;
            color: #2873E9 !important;
        }
    }
    ::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: 2px solid #2873E9;
        color: #2873E9;
    }
}
</style>
